module.exports = __webpack_public_path__ + "static/media/Atomo.2ba39db2.gif";